import type { CastProfileTimeline } from './castProfileTimelines.ts'

// Sourced exceptions to the catalog's main-romance metadata. Provenance:
// research/bio-research-2021-c-2026-10-01.json. Supporting debuts and earlier
// dates must not be overwritten by a later featured romance. No current
// romantic/legal status is inferred from these editorial origin records.
export const editorialOrigins: Record<string, NonNullable<CastProfileTimeline['origin']>> = {
  // Added spinoff credits resolve the former seven-show catalog's later
  // Last Resort starting point. This labels an early documented couple
  // chapter, not an exact first guest appearance in the wider franchise.
  // research/canon-darcey-stacey-2026-10-01.json.
  'p-stacey-silva': {
    partnerName: 'Florian Sukaj', partnerPersonId: 'p-florian-sukaj',
    introLabel: 'Early couple chapter with Florian Sukaj',
    show: 'Darcey & Stacey', season: 1,
  },
  'p-florian-sukaj': {
    partnerName: 'Stacey Silva', partnerPersonId: 'p-stacey-silva',
    introLabel: 'Early couple chapter with Stacey Silva',
    show: 'Darcey & Stacey', season: 1,
  },
  // Independently sourced newcomer profiles, not fabricated couple matches:
  // research/bio-research-2021-c-followup-2026-10-01.json.
  ...Object.fromEntries(['p-sierra-90-day-hunt-for-love-s1', 'p-shelby-90-day-hunt-for-love-s1', 'p-lexie-90-day-hunt-for-love-s1'].map((id) => [id, {
    partnerName: 'Singles retreat', introLabel: 'Joined as a new single', connectionKind: 'independent' as const,
    show: '90 Day: Hunt for Love', season: 1,
  }])),
  // TLC's Season 7 introduction resolves malformed original-partner labels:
  // research/bio-research-legacy-a-2026-10-01.json.
  'p-juliana-custodio': {
    partnerName: 'Michael Jessen', partnerPersonId: 'p-michael-jessen',
    show: '90 Day Fiancé', season: 7,
  },
  'p-michael-jessen': {
    partnerName: 'Juliana Custodio', partnerPersonId: 'p-juliana-custodio',
    show: '90 Day Fiancé', season: 7,
  },
  // Original Melissa connection and unresolved personas are documented in
  // research/bio-research-legacy-b-2026-10-01.json. No invented profile IDs.
  'p-ricky-reyes': {
    partnerName: 'Melissa', show: '90 Day Fiancé: Before the 90 Days', season: 2,
  },
  'p-marta-maldonado': {
    partnerName: '“Daya” online identity', introLabel: 'Online identity: “Daya”',
    connectionKind: 'unverified-identity', show: '90 Day Fiancé: Before the 90 Days', season: 2,
  },
  'p-yolanda-leak': {
    partnerName: '“Williams” online identity', introLabel: 'Online identity: “Williams”',
    connectionKind: 'unverified-identity', show: '90 Day Fiancé: Before the 90 Days', season: 4,
  },
  'p-veronica-rodriguez': {
    partnerName: 'Tim Malcolm', partnerPersonId: 'p-tim-malcolm',
    introLabel: 'Tim’s ex-fiancée and friend',
    show: '90 Day Fiancé: Before the 90 Days', season: 3,
  },
  'p-jamal-menzies': {
    partnerName: 'Kim Menzies', partnerPersonId: 'p-kim-menzies',
    introLabel: 'Kim’s son', connectionKind: 'family',
    show: '90 Day Fiancé: Before the 90 Days', season: 5,
  },
  'p-john-mcmanus': {
    partnerName: 'Patrick Mendes', partnerPersonId: 'p-patrick-mendes',
    introLabel: 'Patrick’s brother', connectionKind: 'family',
    show: '90 Day Fiancé', season: 9,
  },
  'p-debbie-johnson': {
    partnerName: 'Colt Johnson', partnerPersonId: 'p-colt-johnson',
    introLabel: 'Colt’s mother', connectionKind: 'family',
    show: '90 Day Fiancé', season: 6,
  },
  'p-rocky-90-day-hunt-for-love-s1': {
    partnerName: 'Chantel Everett', partnerPersonId: 'p-chantel-everett',
    introLabel: 'An early retreat date with Chantel',
    show: '90 Day: Hunt for Love', season: 1,
  },
}
